export default {
    id: 'MEDCAL_RX_HOME',
    greeting: {
        getText: (name) => `Hi, ${name}!`,
        id: 'MEDCAL_RX_HOME_GREETING'
    },
    secondaryGreetingHTML: (provider, npi) => ({__html: `<b>You are working on behalf of:</b> ${`${provider.providerFirstName ? provider.providerFirstName : '' }${provider.providerFirstName ? ' ' : ''}${provider.providerLastName}`} (NPI:${npi})`}) ,
    title: {
        text: 'Welcome to the Medi-Cal Rx Prior Authorization (PA) System',
        id: 'MEDCAL_RX_HOME_TITLE'
    },
    icons:{
        create:{
            to: '/create',
            text: 'Create New PA',
            type: 'img',
            id: 'MEDCAL_RX_CREATE_PA'
        },
        inquiry:{
            to: '/inquiry',
            text: 'Inquiry on PA',
            type: 'img',
            id: 'MEDCAL_RX_INQUIRY_PA'
        },
        cancel:{
            to: '/cancel',
            text: 'Cancel PA',
            type: 'img',
            id: 'MEDCAL_RX_CANCEL_PA'
        },
        update:{
            to: '/update',
            text: 'Add Information to Existing PA',
            type: 'img',
            id: 'MEDCAL_RX_UPDATE_PA'
        },
        upload:{
            to: '/upload',
            text: 'Upload Attachments to Existing PA',
            type: 'img',
            id: 'MEDCAL_RX_UPLOAD_PA'
        }
    },
    jobAid: {
        text: 'For instructions, refer to ',
        link: '/cms/medicalrx/static-assets/documents/provider/forms-and-information/Medi-Cal_Rx_Prior_Authorization_Job_Aid.pdf',
        linkText: 'Medi-Cal Rx Portal PA Request Job Aid',
        id: 'MEDCAL_RX_JOB_AID_PA'
    }
}